export default __webpack_public_path__ + "static/media/lock.2593b863.svg";